export default __webpack_public_path__ + "static/media/games-banners-ms.4720499e.webp";